/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

const PlaceholderRow = styled.div`
  height: ${({ height }) => height};
  background-color: ${getColor('catskillWhite')};
  border-radius: ${({ borderRadius }) => borderRadius};
  width: ${({ width }) => width};
`;

export const SkeletonRow = ({
  width = '100%',
  height = '1rem',
  borderRadius = '3rem',
  ...rest
}) => (
  <PlaceholderRow
    width={width}
    height={height}
    borderRadius={borderRadius}
    {...rest}
  />
);
